module.exports = __webpack_public_path__ + "static/media/insights.fad66bed.svg";